import { SVLS_API_CLIENT } from '../App.utils';
import { BRAND_DOMAIN, SKIN_NAME } from '../constants/Branding';

/** Fire-and-forget APK download click tracking. Does not block the download. */
export const trackApkDownload = (source: string): void => {
  if (!source) return;
  SVLS_API_CLIENT.post(`/account/v2/books/${BRAND_DOMAIN}/apk-downloads`, {
    skin: SKIN_NAME,
    source,
  }).catch(() => {});
};
